import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, CheckIcon } from 'lucide-react';
export function HcpExampleSlide({
  onDone,
  onBack
}: {
  onDone: () => void;
  onBack: () => void;
}) {
  const patients = [{
    id: 'P01',
    symptom: 'Lump',
    duration: '6 weeks',
    change: 'Growing',
    imaging: 'No',
    clinic: 'Urgent clinic',
    color: 'rose'
  }, {
    id: 'P02',
    symptom: 'Pain',
    duration: '2 weeks',
    change: 'Stable',
    imaging: 'No',
    clinic: 'Routine clinic',
    color: 'amber'
  }, {
    id: 'P03',
    symptom: 'Lump',
    duration: '4 weeks',
    change: 'Stable',
    imaging: 'Yes',
    clinic: 'Imaging review',
    color: 'sky'
  }, {
    id: 'P04',
    symptom: 'Lump',
    duration: '2 weeks',
    change: 'Not sure',
    imaging: 'No',
    clinic: 'Consultant review',
    color: 'slate'
  }];
  return <div className="flex flex-col h-full px-6 py-8 relative z-10 bg-slate-950 text-slate-300" data-id="element-145">
      <div className="flex items-center justify-between mb-6" data-id="element-146">
        <button onClick={onBack} className="p-2 -ml-2 text-slate-400 hover:text-white transition-colors bg-slate-900 rounded-full shadow-sm border border-slate-800" aria-label="Go back" data-id="element-147">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-148" />
        </button>
      </div>

      <div className="flex-1 flex flex-col max-w-sm mx-auto w-full overflow-y-auto no-scrollbar pb-24" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-6" data-id="element-150">
          <h2 className="text-2xl font-semibold text-white leading-tight mb-2" data-id="element-151">
            Example of structured patient review
          </h2>
        </motion.div>

        {/* Table-style cards for mobile */}
        <div className="space-y-3 mb-8" data-id="element-152">
          {patients.map((p, i) => <motion.div key={p.id} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2 + i * 0.1
        }} className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden" data-id="element-153">
              <div className="px-4 py-2 bg-slate-800/50 border-b border-slate-800 flex justify-between items-center" data-id="element-154">
                <span className="text-white font-bold text-sm" data-id="element-155">{p.id}</span>
                <span className={`text-${p.color}-400 text-[10px] font-bold uppercase tracking-wider bg-${p.color}-500/10 px-2 py-0.5 rounded`} data-id="element-156">
                  {p.clinic}
                </span>
              </div>
              <div className="p-4 grid grid-cols-2 gap-y-3 gap-x-4 text-xs" data-id="element-157">
                <div data-id="element-158">
                  <span className="text-slate-500 block mb-0.5" data-id="element-159">Symptom</span>
                  <span className="text-slate-300 font-medium" data-id="element-160">
                    {p.symptom}
                  </span>
                </div>
                <div data-id="element-161">
                  <span className="text-slate-500 block mb-0.5" data-id="element-162">Duration</span>
                  <span className="text-slate-300 font-medium" data-id="element-163">
                    {p.duration}
                  </span>
                </div>
                <div data-id="element-164">
                  <span className="text-slate-500 block mb-0.5" data-id="element-165">Change</span>
                  <span className="text-slate-300 font-medium" data-id="element-166">{p.change}</span>
                </div>
                <div data-id="element-167">
                  <span className="text-slate-500 block mb-0.5" data-id="element-168">
                    Prev. imaging
                  </span>
                  <span className="text-slate-300 font-medium" data-id="element-169">
                    {p.imaging}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="bg-slate-800/50 border border-slate-700/50 p-4 rounded-xl" data-id="element-170">
          <p className="text-sm text-slate-400 leading-relaxed text-center" data-id="element-171">
            Instead of reading unstructured referrals, clinicians can review
            structured patient signals.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1
    }} className="absolute bottom-6 left-6 right-6" data-id="element-172">
        <button onClick={onDone} className="w-full py-4 bg-slate-800 text-white border border-slate-700 rounded-xl font-semibold text-lg flex items-center justify-center hover:bg-slate-700 transition-colors shadow-lg active:scale-[0.98]" data-id="element-173">
          <CheckIcon className="w-5 h-5 mr-2" data-id="element-174" />
          Finish
        </button>
      </motion.div>
    </div>;
}